export default function validateTestAdditionalInformationFieldOptionName(value?: string) {
  let error;
  return error;
}
